/**
 * Larghezze della barra della coda (da `sm`): nessun campo cambia misura quando un filtro si attiva o si
 * toglie, quindi la barra va a capo sempre negli stessi punti (#105, considerazioni del 16/10/2026).
 * Un valore più lungo del campo finisce con i puntini; la voce intera è nel menu.
 *
 * Misurate sul testo reale (Inter 14px più 58px fra margine e freccia): «Tutti i committenti», «In attesa
 * dell'utente» e «Risposta ricevuta» si leggono interi. Ricerca e i primi quattro filtri stanno in una riga
 * da una barra di 900px, cioè 1280px con la sidebar aperta anche con la barra di scorrimento del browser.
 * Il quinto filtro, «Risposta» (#122), è largo quanto basta perché con lui la prima riga superi i 1080px:
 * a 1280 e a 1440px va a capo, sempre, con «Azzera filtri» e «Ordina per» nella seconda riga (con o senza
 * barra di scorrimento, che a 1440px toglie circa 15px). Sale nella prima riga da circa 1090px di barra.
 */
export const QUEUE_TOOLBAR_WIDTHS = {
  /** Base e massimo della ricerca: cresce fino a 360px (come nel prototipo) nello spazio della propria riga. */
  search: { min: 212, max: 360 },
  committente: 176,
  priority: 140,
  state: 188,
  assignee: 152,
  reply: 176,
  sort: 252,
} as const;
